import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Container, createTheme } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import { Box } from "@mui/system";
import Footer from "./components/Footer";

const theme = createTheme({
  palette: {
    primary: {
      light: "#757ce8",
      main: "#ffdc97",
      dark: "#002884",
      contrastText: "#fff",
    },
    secondary: {
      light: "#fff",
      main: "#cecece",
      dark: "#000",
      contrastText: "#000",
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
